<span
  [attr.role]="preview() ? null : 'button'"
  (click)="toggle()"
  (keydown.enter)="toggle()"
  [attr.aria-pressed]="unblurred"
  [class.unblurred]="unblurred"
  [attr.tabindex]="preview() ? -1 : 0"
  [innerHTML]="content()"
  [class.preview]="preview()"
  class="spoiler"></span>
